// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"083edff6","466":"0ea1bb70","738":"8ca221e0","787":"1badf596","856":"192189e5"}[chunkId] + ".chunk.js";
};